// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { Date, DateSchema } from 'api/gen/Date';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { PositiveInteger, PositiveIntegerSchema } from 'api/gen/PositiveInteger';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { SubjectBusinessName, SubjectBusinessNameSchema } from 'api/gen/SubjectBusinessName';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { SubjectCode, SubjectCodeSchema } from 'api/gen/SubjectCode';

const requiredPart = t.interface({
  approvedFrom: DateSchema,
  approvedTo: t.union([DateSchema, t.null]),
  businessName: SubjectBusinessNameSchema,
  code: SubjectCodeSchema,
  subjectId: PositiveIntegerSchema,
  subjectUserProfileId: PositiveIntegerSchema,
});

export const UserSubjectViewSchema = excess(requiredPart);

export interface UserSubjectView extends t.TypeOf<typeof UserSubjectViewSchema> {}
